import { getTagDisplayValue } from "../../utility/constantsTagsUtils";
import { Constants } from "../graph/StateTags";
import { isTagEntry, RowDef } from "./cells/cellUtils";
import { GridSortItem } from '@mui/x-data-grid-pro';

export function stringSort(key: keyof RowDef, sortItem: GridSortItem, constants: Constants)
{
    const compare = (a: string, b: string) => a.localeCompare(b);
    const reverseCompare = (a: string, b: string) => b.localeCompare(a);

    const activeFunc = sortItem.sort === "asc" ? compare : reverseCompare;

    return ((a: RowDef, b: RowDef) =>
    {
        const fieldA = a[key] ?? "";
        const fieldB = b[key] ?? "";
        const aValue = isTagEntry(fieldA) ? getTagDisplayValue(fieldA.tags[0], constants) : fieldA;
        const bValue = isTagEntry(fieldB) ? getTagDisplayValue(fieldB.tags[0], constants) : fieldB;

        return activeFunc(String(aValue), String(bValue));
    });
};

export function numberSort(key: keyof RowDef, sortItem: GridSortItem)
{
    const compare = (a: number, b: number) => a - b;
    const reverseCompare = (a: number, b: number) => b - a;

    const activeFunc = sortItem.sort === "asc" ? compare : reverseCompare;

    return ((a: RowDef, b: RowDef) =>
    {
        const fieldA = a[key] ?? 0;
        const fieldB = b[key] ?? 0;
        const aValue = isTagEntry(fieldA) ? fieldA.tags[0].value : fieldA;
        const bValue = isTagEntry(fieldB) ? fieldB.tags[0].value : fieldB;

        return activeFunc(Number(aValue), (Number(bValue)));
    });
};